<template>
    <div class="active-filters uk-margin-bottom">
        <div class="uk-flex-middle uk-grid uk-grid-xsmall uk-grid-stack" uk-grid>
            <div v-for="(obj, key, index) in items"
                :key="index"
                @click="removeArg"
            >
                <button class="uk-button uk-button-indigo-outline uk-flex uk-flex-middle"  :data-value="obj.value" :data-type="obj.type" :title="obj.displayName" type="button">
                    <span>{{ formatLocation(obj.displayName) }}</span>
                    <span class="uk-margin-xsmall-left uk-icon uk-disabled" uk-icon="close"></span>
                </button>
            </div>
            <div>
                <button @click="clearFilters" class="uk-button uk-link-indigo uk-button-link" type="button">{{ $t("message.clear_filters")}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
      name: 'active-filters',
      props: ['items'],
      methods: {
        removeArg: function(a){
          this.$emit('filter-arg-removed', [a.target.dataset.type, a.target.dataset.value])
        },
        clearFilters: function(){
          this.$emit('cleared-filters')
        },
        formatLocation: function(l){
          if (typeof l == 'string' && l.indexOf(',') > -1){
            let location = l.split(',');
            if (location[location.length - 1].trim() === 'United States') {
              return l.replace(/United States/gi, 'USA')
            } else if (location[1].trim() === 'United Kingdom') {
              return l.replace(/United Kingdom/gi, 'UK')
            }
          }
          return l
        }
      }
    }
</script>
